export type QuickStartSource = "calendar" | "flowboard";

export interface ResolveFinishRedirectArgs {
  isQuickStartFlow: boolean;
  quickStartSource?: QuickStartSource;
  fromCalendar?: boolean;
  petId: string;
  appointmentId?: string | null;
}

export type FinishRedirect =
  | { to: string; state?: Record<string, unknown> }
  | { smartBackTo: string };

/**
 * Decides where to send the user after finishing a medical record.
 *
 * - Quick-started from Flowboard: back to Flowboard, reopening the appointment.
 * - Quick-started from the Calendar (or quickStartSource unset, which the
 *   controller only leaves unset when it defaults to "calendar"): back to the
 *   Calendar, reopening that appointment (Calendar.tsx already listens for
 *   `location.state.appointmentId`).
 * - Not a quick start but reached from the calendar: smart-back to /calendar.
 * - Otherwise: smart-back to the patient's history tab.
 */
export function resolveFinishRedirect({
  isQuickStartFlow,
  quickStartSource,
  fromCalendar,
  petId,
  appointmentId,
}: ResolveFinishRedirectArgs): FinishRedirect {
  if (isQuickStartFlow) {
    if (quickStartSource === "flowboard") {
      return {
        to: "/calendar/flowboard",
        state: { openAppointmentId: appointmentId ?? undefined, fromQuickStart: true },
      };
    }
    return {
      to: "/calendar",
      state: { appointmentId: appointmentId ?? undefined },
    };
  }

  if (fromCalendar) {
    return { smartBackTo: "/calendar" };
  }

  return { smartBackTo: `/patients/pets/${petId}/history` };
}
